export default "__VITE_ASSET__CQw010U6__"